module.exports = __webpack_public_path__ + "static/media/img_fenlei15.d7c5ed43.png";